module.exports = __webpack_public_path__ + "img/8.fbc3d8e9.jpg";